import type { RegionCode } from "@penn/web-common";

export const GUEST_REGION_COOKIE_NAME = "penn_guest_region";
export const DEFAULT_GUEST_REGION: RegionCode = "NA";

const VALID_REGIONS: ReadonlySet<RegionCode> = new Set(["EU", "NA", "ASIA"]);

export function parseGuestRegionCookie(
  cookieHeader: string,
): RegionCode | null {
  for (const pair of cookieHeader.split(";")) {
    const separator = pair.indexOf("=");
    if (separator < 0) continue;
    const name = pair.slice(0, separator).trim();
    if (name !== GUEST_REGION_COOKIE_NAME) continue;

    let value: string;
    try {
      value = decodeURIComponent(pair.slice(separator + 1).trim());
    } catch {
      return null;
    }
    return VALID_REGIONS.has(value as RegionCode)
      ? (value as RegionCode)
      : null;
  }
  return null;
}

export function readGuestRegionCookie(): RegionCode | null {
  if (typeof document === "undefined") return null;
  return parseGuestRegionCookie(document.cookie);
}

export function resolveEffectiveRegion(input: {
  isAuthenticated: boolean;
  selectedRegion: string | null | undefined;
  userRegion: string | null | undefined;
  guestRegion: RegionCode | null;
}): RegionCode {
  if (input.isAuthenticated) {
    if (VALID_REGIONS.has(input.selectedRegion as RegionCode)) {
      return input.selectedRegion as RegionCode;
    }
    if (VALID_REGIONS.has(input.userRegion as RegionCode)) {
      return input.userRegion as RegionCode;
    }
    return DEFAULT_GUEST_REGION;
  }

  return input.guestRegion ?? DEFAULT_GUEST_REGION;
}
